<template>
  <div>
    <span class="clickable">
      <a href="#" @click.stop="displayMedia()">
        <span class="empty">
          <i class="fas fa-file-pdf fa-3x"></i>
        </span>
      </a>
    </span>
  </div>
</template>

<script>
import imagePreview from '@/components/common/image-preview'
export default {
  components: {
    imagePreview
  },
  props: {
    value: { type: null, default: '' }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(model) {
        this.$emit('input', model)
      }
    }
  },
  watch: {
    model(val) {
      this.$emit('input', val)
    },
    value(val) {
      this.model = val
    }
  },
  methods: {
    displayMedia() {
      window.open(this.model.url)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/common/media/pdf-preview.vue